import { authService } from "@/services";
import { useMutation } from "@tanstack/react-query";

export const loginKey = "login";
export const registerkey = "register";

export const useLogin = (options) =>
  useMutation({
    mutationKey: loginKey,
    mutationFn: (credentials) => authService.login(credentials),
    ...options,
  });

export const useRegister = (options) =>
  useMutation({
    mutationKey: registerkey,
    mutationFn: (credentials) => authService.register(credentials),
    ...options,
  });